import { render } from "./Main.vue?vue&type=template&id=20a3861e"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=20a3861e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\business-support\\applicant.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__